/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { UserRepresentation } from '../model/userRepresentation';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class UsersApi extends BaseApi {
    executeAction(userId, actionRequest) {
        throwIfNotDefined(userId, 'userId');
        throwIfNotDefined(actionRequest, 'actionRequest');
        const pathParams = {
            userId
        };
        return this.post({
            path: '/api/enterprise/users/{userId}',
            pathParams,
            bodyParam: actionRequest
        });
    }
    getUserProfilePictureUrl(userId) {
        return this.apiClient.basePath + '/app/rest/users/' + userId + '/picture';
    }
    getUser(userId) {
        throwIfNotDefined(userId, 'userId');
        const pathParams = {
            userId
        };
        return this.get({
            path: '/api/enterprise/users/{userId}',
            pathParams,
            returnType: UserRepresentation
        });
    }
    getUsers(opts) {
        opts = opts || {};
        const queryParams = {
            filter: opts['filter'],
            email: opts['email'],
            externalId: opts['externalId'],
            externalIdCaseInsensitive: opts['externalIdCaseInsensitive'],
            excludeTaskId: opts['excludeTaskId'],
            excludeProcessId: opts['excludeProcessId'],
            groupId: opts['groupId'],
            tenantId: opts['tenantId']
        };
        return this.get({
            path: '/api/enterprise/users',
            queryParams
        });
    }
    requestPasswordReset(resetPassword) {
        throwIfNotDefined(resetPassword, 'resetPassword');
        return this.post({
            path: '/api/enterprise/idm/passwords',
            bodyParam: resetPassword
        });
    }
    updateUser(userId, userRequest) {
        throwIfNotDefined(userId, 'userId');
        throwIfNotDefined(userRequest, 'userRequest');
        const pathParams = {
            userId
        };
        return this.put({
            path: '/api/enterprise/users/{userId}',
            pathParams,
            bodyParam: userRequest,
            returnType: UserRepresentation
        });
    }
}
